export type TGamesLocaleUi = {
  play: string;
  rules: string;
  demoPlay: string;
  maxEntryFee: string;
  goToGameAria: string;
  notFound: {
    title: string;
    backLink: string;
  };
  moreGames: string;
  demo: {
    title: string;
    difficulty: string;
    difficultyAria: string;
    apply: string;
    player: string;
    opponent: string;
  };
};

export const gamesUi: TGamesLocaleUi = {
  play: 'Play!',
  rules: 'Rules',
  demoPlay: 'Demo play',
  maxEntryFee: 'Max entry fee {{amount}}$',
  goToGameAria: 'Go to {{name}}',
  notFound: {
    title: 'Game Not Found',
    backLink: 'Back to games',
  },
  moreGames: 'more<accent> games</accent>',
  demo: {
    title: 'Demo play',
    difficulty: 'Difficulty: {{percent}}%',
    difficultyAria: 'Difficulty',
    apply: 'Apply',
    player: 'You',
    opponent: 'Bot',
  },
};
